import { h, Component } from 'preact';
import Loadable from 'react-loadable';
import { isMobileRequest } from '../../utils/CommonHelper.js';

const SnbDesktop = Loadable({
    loader: () => import('../../../../q-cars/src/containers/SNB/desktop/snb.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        const SnbDesktop = loaded.default;
        return <SnbDesktop {...props} />;
    }
});

const SnbMsite = Loadable({
    loader: () => import('../../../../q-cars/src/containers/SNB/snb.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        const SnbMsite = loaded.default;
        return <SnbMsite {...props} />;
    }
});

export default class SNB extends Component {

    render(props) {
        return isMobileRequest() ? <SnbMsite {...props}/> : <SnbDesktop {...props}/> ;
    }
}


// WEBPACK FOOTER //
// ../q-cars/src/containers/SNB/index.js